/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from 'ethers';
import type { Provider, TransactionRequest } from '@ethersproject/providers';
import type { PromiseOrValue } from '../common';
import type { OrderBookRouter, OrderBookRouterInterface } from '../OrderBookRouter';

const _abi = [
  {
    inputs: [
      {
        internalType: 'contract ERC20',
        name: '_cashToken',
        type: 'address',
      },
      {
        internalType: 'address',
        name: '_cashWallet',
        type: 'address',
      },
      {
        internalType: 'address',
        name: '_policyWallet',
        type: 'address',
      },
    ],
    stateMutability: 'nonpayable',
    type: 'constructor',
  },
  {
    inputs: [],
    name: 'Init',
    type: 'error',
  },
  {
    inputs: [],
    name: 'InvalidOrder',
    type: 'error',
  },
  {
    inputs: [],
    name: 'cashToken',
    outputs: [
      {
        internalType: 'contract ERC20',
        name: '',
        type: 'address',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'cashWallet',
    outputs: [
      {
        internalType: 'address',
        name: '',
        type: 'address',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'factory',
    outputs: [
      {
        internalType: 'contract MerkleOrderbookFactory',
        name: '',
        type: 'address',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: '_factory',
        type: 'address',
      },
    ],
    name: 'init',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: 'uint256',
            name: 'orderBookIndex',
            type: 'uint256',
          },
          {
            components: [
              {
                components: [
                  {
                    components: [
                      {
                        internalType: 'address',
                        name: 'maker',
                        type: 'address',
                      },
                      {
                        internalType: 'bool',
                        name: 'isSell',
                        type: 'bool',
                      },
                      {
                        internalType: 'bool',
                        name: 'isCollateralOrder',
                        type: 'bool',
                      },
                      {
                        internalType: 'uint256',
                        name: 'orderAmount',
                        type: 'uint256',
                      },
                      {
                        internalType: 'uint256',
                        name: 'orderPrice',
                        type: 'uint256',
                      },
                      {
                        internalType: 'uint256',
                        name: 'index',
                        type: 'uint256',
                      },
                    ],
                    internalType: 'struct Order',
                    name: 'order',
                    type: 'tuple',
                  },
                  {
                    internalType: 'bytes32[]',
                    name: 'proofs',
                    type: 'bytes32[]',
                  },
                  {
                    internalType: 'uint8',
                    name: 'bits',
                    type: 'uint8',
                  },
                ],
                internalType: 'struct OrderWithProofs',
                name: 'cancelOrder',
                type: 'tuple',
              },
              {
                internalType: 'bytes',
                name: 'cancelOrderSignature',
                type: 'bytes',
              },
              {
                components: [
                  {
                    components: [
                      {
                        internalType: 'address',
                        name: 'maker',
                        type: 'address',
                      },
                      {
                        internalType: 'bool',
                        name: 'isSell',
                        type: 'bool',
                      },
                      {
                        internalType: 'bool',
                        name: 'isCollateralOrder',
                        type: 'bool',
                      },
                      {
                        internalType: 'uint256',
                        name: 'orderAmount',
                        type: 'uint256',
                      },
                      {
                        internalType: 'uint256',
                        name: 'orderPrice',
                        type: 'uint256',
                      },
                      {
                        internalType: 'uint256',
                        name: 'index',
                        type: 'uint256',
                      },
                    ],
                    internalType: 'struct Order',
                    name: 'order',
                    type: 'tuple',
                  },
                  {
                    internalType: 'bytes32[]',
                    name: 'proofs',
                    type: 'bytes32[]',
                  },
                  {
                    internalType: 'uint8',
                    name: 'bits',
                    type: 'uint8',
                  },
                ],
                internalType: 'struct OrderWithProofs',
                name: 'nextOrder',
                type: 'tuple',
              },
              {
                components: [
                  {
                    components: [
                      {
                        internalType: 'address',
                        name: 'maker',
                        type: 'address',
                      },
                      {
                        internalType: 'bool',
                        name: 'isSell',
                        type: 'bool',
                      },
                      {
                        internalType: 'bool',
                        name: 'isCollateralOrder',
                        type: 'bool',
                      },
                      {
                        internalType: 'uint256',
                        name: 'orderAmount',
                        type: 'uint256',
                      },
                      {
                        internalType: 'uint256',
                        name: 'orderPrice',
                        type: 'uint256',
                      },
                      {
                        internalType: 'uint256',
                        name: 'index',
                        type: 'uint256',
                      },
                    ],
                    internalType: 'struct Order',
                    name: 'order',
                    type: 'tuple',
                  },
                  {
                    internalType: 'bytes32[]',
                    name: 'proofs',
                    type: 'bytes32[]',
                  },
                  {
                    internalType: 'uint8',
                    name: 'bits',
                    type: 'uint8',
                  },
                ],
                internalType: 'struct OrderWithProofs',
                name: 'prevOrder',
                type: 'tuple',
              },
            ],
            internalType: 'struct CancelOrderReq[]',
            name: 'cancelledOrders',
            type: 'tuple[]',
          },
          {
            components: [
              {
                components: [
                  {
                    components: [
                      {
                        internalType: 'address',
                        name: 'maker',
                        type: 'address',
                      },
                      {
                        internalType: 'bool',
                        name: 'isSell',
                        type: 'bool',
                      },
                      {
                        internalType: 'bool',
                        name: 'isCollateralOrder',
                        type: 'bool',
                      },
                      {
                        internalType: 'uint256',
                        name: 'orderAmount',
                        type: 'uint256',
                      },
                      {
                        internalType: 'uint256',
                        name: 'orderPrice',
                        type: 'uint256',
                      },
                      {
                        internalType: 'uint256',
                        name: 'index',
                        type: 'uint256',
                      },
                    ],
                    internalType: 'struct Order',
                    name: 'order',
                    type: 'tuple',
                  },
                  {
                    internalType: 'bytes32[]',
                    name: 'proofs',
                    type: 'bytes32[]',
                  },
                  {
                    internalType: 'uint8',
                    name: 'bits',
                    type: 'uint8',
                  },
                ],
                internalType: 'struct OrderWithProofs',
                name: 'newOrder',
                type: 'tuple',
              },
              {
                internalType: 'bytes',
                name: 'newOrderSignature',
                type: 'bytes',
              },
              {
                components: [
                  {
                    internalType: 'address',
                    name: 'maker',
                    type: 'address',
                  },
                  {
                    internalType: 'bool',
                    name: 'isSell',
                    type: 'bool',
                  },
                  {
                    internalType: 'bool',
                    name: 'isCollateralOrder',
                    type: 'bool',
                  },
                  {
                    internalType: 'uint256',
                    name: 'orderAmount',
                    type: 'uint256',
                  },
                  {
                    internalType: 'uint256',
                    name: 'orderPrice',
                    type: 'uint256',
                  },
                  {
                    internalType: 'uint256',
                    name: 'index',
                    type: 'uint256',
                  },
                ],
                internalType: 'struct Order',
                name: 'headOrder',
                type: 'tuple',
              },
              {
                components: [
                  {
                    components: [
                      {
                        internalType: 'address',
                        name: 'maker',
                        type: 'address',
                      },
                      {
                        internalType: 'bool',
                        name: 'isSell',
                        type: 'bool',
                      },
                      {
                        internalType: 'bool',
                        name: 'isCollateralOrder',
                        type: 'bool',
                      },
                      {
                        internalType: 'uint256',
                        name: 'orderAmount',
                        type: 'uint256',
                      },
                      {
                        internalType: 'uint256',
                        name: 'orderPrice',
                        type: 'uint256',
                      },
                      {
                        internalType: 'uint256',
                        name: 'index',
                        type: 'uint256',
                      },
                    ],
                    internalType: 'struct Order',
                    name: 'order',
                    type: 'tuple',
                  },
                  {
                    internalType: 'bytes32[]',
                    name: 'proofs',
                    type: 'bytes32[]',
                  },
                  {
                    internalType: 'uint8',
                    name: 'bits',
                    type: 'uint8',
                  },
                ],
                internalType: 'struct OrderWithProofs',
                name: 'prevOrder',
                type: 'tuple',
              },
              {
                components: [
                  {
                    components: [
                      {
                        internalType: 'address',
                        name: 'maker',
                        type: 'address',
                      },
                      {
                        internalType: 'bool',
                        name: 'isSell',
                        type: 'bool',
                      },
                      {
                        internalType: 'bool',
                        name: 'isCollateralOrder',
                        type: 'bool',
                      },
                      {
                        internalType: 'uint256',
                        name: 'orderAmount',
                        type: 'uint256',
                      },
                      {
                        internalType: 'uint256',
                        name: 'orderPrice',
                        type: 'uint256',
                      },
                      {
                        internalType: 'uint256',
                        name: 'index',
                        type: 'uint256',
                      },
                    ],
                    internalType: 'struct Order',
                    name: 'order',
                    type: 'tuple',
                  },
                  {
                    internalType: 'bytes32[]',
                    name: 'proofs',
                    type: 'bytes32[]',
                  },
                  {
                    internalType: 'uint8',
                    name: 'bits',
                    type: 'uint8',
                  },
                ],
                internalType: 'struct OrderWithProofs',
                name: 'injectOrder',
                type: 'tuple',
              },
            ],
            internalType: 'struct MakeOrderReq',
            name: 'req',
            type: 'tuple',
          },
        ],
        internalType: 'struct RouterMakeOrderReq[]',
        name: 'reqs',
        type: 'tuple[]',
      },
    ],
    name: 'makeOrderMany',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: 'orderBookIndex',
        type: 'uint256',
      },
      {
        internalType: 'address[]',
        name: '_to',
        type: 'address[]',
      },
      {
        internalType: 'uint256[]',
        name: 'numShares',
        type: 'uint256[]',
      },
      {
        internalType: 'uint256',
        name: 'amtPerShare',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'totalAmount',
        type: 'uint256',
      },
    ],
    name: 'newPayouts',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [],
    name: 'policyWallet',
    outputs: [
      {
        internalType: 'contract PolicyWallet',
        name: '',
        type: 'address',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: 'uint256',
            name: 'orderBookIndex',
            type: 'uint256',
          },
          {
            internalType: 'uint256',
            name: 'amount',
            type: 'uint256',
          },
          {
            components: [
              {
                components: [
                  {
                    internalType: 'address',
                    name: 'maker',
                    type: 'address',
                  },
                  {
                    internalType: 'bool',
                    name: 'isSell',
                    type: 'bool',
                  },
                  {
                    internalType: 'bool',
                    name: 'isCollateralOrder',
                    type: 'bool',
                  },
                  {
                    internalType: 'uint256',
                    name: 'orderAmount',
                    type: 'uint256',
                  },
                  {
                    internalType: 'uint256',
                    name: 'orderPrice',
                    type: 'uint256',
                  },
                  {
                    internalType: 'uint256',
                    name: 'index',
                    type: 'uint256',
                  },
                ],
                internalType: 'struct Order',
                name: 'order',
                type: 'tuple',
              },
              {
                internalType: 'bytes32[]',
                name: 'proofs',
                type: 'bytes32[]',
              },
              {
                internalType: 'uint8',
                name: 'bits',
                type: 'uint8',
              },
            ],
            internalType: 'struct OrderWithProofs',
            name: 'headOrder',
            type: 'tuple',
          },
          {
            components: [
              {
                components: [
                  {
                    internalType: 'address',
                    name: 'maker',
                    type: 'address',
                  },
                  {
                    internalType: 'bool',
                    name: 'isSell',
                    type: 'bool',
                  },
                  {
                    internalType: 'bool',
                    name: 'isCollateralOrder',
                    type: 'bool',
                  },
                  {
                    internalType: 'uint256',
                    name: 'orderAmount',
                    type: 'uint256',
                  },
                  {
                    internalType: 'uint256',
                    name: 'orderPrice',
                    type: 'uint256',
                  },
                  {
                    internalType: 'uint256',
                    name: 'index',
                    type: 'uint256',
                  },
                ],
                internalType: 'struct Order',
                name: 'order',
                type: 'tuple',
              },
              {
                internalType: 'bytes32[]',
                name: 'proofs',
                type: 'bytes32[]',
              },
              {
                internalType: 'uint8',
                name: 'bits',
                type: 'uint8',
              },
            ],
            internalType: 'struct OrderWithProofs',
            name: 'headsNextOrder',
            type: 'tuple',
          },
          {
            components: [
              {
                components: [
                  {
                    components: [
                      {
                        internalType: 'address',
                        name: 'maker',
                        type: 'address',
                      },
                      {
                        internalType: 'bool',
                        name: 'isSell',
                        type: 'bool',
                      },
                      {
                        internalType: 'bool',
                        name: 'isCollateralOrder',
                        type: 'bool',
                      },
                      {
                        internalType: 'uint256',
                        name: 'orderAmount',
                        type: 'uint256',
                      },
                      {
                        internalType: 'uint256',
                        name: 'orderPrice',
                        type: 'uint256',
                      },
                      {
                        internalType: 'uint256',
                        name: 'index',
                        type: 'uint256',
                      },
                    ],
                    internalType: 'struct Order',
                    name: 'order',
                    type: 'tuple',
                  },
                  {
                    internalType: 'bytes32[]',
                    name: 'proofs',
                    type: 'bytes32[]',
                  },
                  {
                    internalType: 'uint8',
                    name: 'bits',
                    type: 'uint8',
                  },
                ],
                internalType: 'struct OrderWithProofs',
                name: 'cancelOrder',
                type: 'tuple',
              },
              {
                internalType: 'bytes',
                name: 'cancelOrderSignature',
                type: 'bytes',
              },
              {
                components: [
                  {
                    components: [
                      {
                        internalType: 'address',
                        name: 'maker',
                        type: 'address',
                      },
                      {
                        internalType: 'bool',
                        name: 'isSell',
                        type: 'bool',
                      },
                      {
                        internalType: 'bool',
                        name: 'isCollateralOrder',
                        type: 'bool',
                      },
                      {
                        internalType: 'uint256',
                        name: 'orderAmount',
                        type: 'uint256',
                      },
                      {
                        internalType: 'uint256',
                        name: 'orderPrice',
                        type: 'uint256',
                      },
                      {
                        internalType: 'uint256',
                        name: 'index',
                        type: 'uint256',
                      },
                    ],
                    internalType: 'struct Order',
                    name: 'order',
                    type: 'tuple',
                  },
                  {
                    internalType: 'bytes32[]',
                    name: 'proofs',
                    type: 'bytes32[]',
                  },
                  {
                    internalType: 'uint8',
                    name: 'bits',
                    type: 'uint8',
                  },
                ],
                internalType: 'struct OrderWithProofs',
                name: 'nextOrder',
                type: 'tuple',
              },
              {
                components: [
                  {
                    components: [
                      {
                        internalType: 'address',
                        name: 'maker',
                        type: 'address',
                      },
                      {
                        internalType: 'bool',
                        name: 'isSell',
                        type: 'bool',
                      },
                      {
                        internalType: 'bool',
                        name: 'isCollateralOrder',
                        type: 'bool',
                      },
                      {
                        internalType: 'uint256',
                        name: 'orderAmount',
                        type: 'uint256',
                      },
                      {
                        internalType: 'uint256',
                        name: 'orderPrice',
                        type: 'uint256',
                      },
                      {
                        internalType: 'uint256',
                        name: 'index',
                        type: 'uint256',
                      },
                    ],
                    internalType: 'struct Order',
                    name: 'order',
                    type: 'tuple',
                  },
                  {
                    internalType: 'bytes32[]',
                    name: 'proofs',
                    type: 'bytes32[]',
                  },
                  {
                    internalType: 'uint8',
                    name: 'bits',
                    type: 'uint8',
                  },
                ],
                internalType: 'struct OrderWithProofs',
                name: 'prevOrder',
                type: 'tuple',
              },
            ],
            internalType: 'struct CancelOrderReq[]',
            name: 'cancelledOrders',
            type: 'tuple[]',
          },
        ],
        internalType: 'struct RouterTakeReq[]',
        name: 'reqs',
        type: 'tuple[]',
      },
    ],
    name: 'takeMany',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
];

const _bytecode =
  '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';

type OrderBookRouterConstructorParams = [signer?: Signer] | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (xs: OrderBookRouterConstructorParams): xs is ConstructorParameters<typeof ContractFactory> =>
  xs.length > 1;

export class OrderBookRouter__factory extends ContractFactory {
  constructor(...args: OrderBookRouterConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
    this.contractName = 'OrderBookRouter';
  }

  override deploy(
    _cashToken: PromiseOrValue<string>,
    _cashWallet: PromiseOrValue<string>,
    _policyWallet: PromiseOrValue<string>,
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): Promise<OrderBookRouter> {
    return super.deploy(_cashToken, _cashWallet, _policyWallet, overrides || {}) as Promise<OrderBookRouter>;
  }
  override getDeployTransaction(
    _cashToken: PromiseOrValue<string>,
    _cashWallet: PromiseOrValue<string>,
    _policyWallet: PromiseOrValue<string>,
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(_cashToken, _cashWallet, _policyWallet, overrides || {});
  }
  override attach(address: string): OrderBookRouter {
    return super.attach(address) as OrderBookRouter;
  }
  override connect(signer: Signer): OrderBookRouter__factory {
    return super.connect(signer) as OrderBookRouter__factory;
  }
  static readonly contractName: 'OrderBookRouter';

  public readonly contractName: 'OrderBookRouter';

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): OrderBookRouterInterface {
    return new utils.Interface(_abi) as OrderBookRouterInterface;
  }
  static connect(address: string, signerOrProvider: Signer | Provider): OrderBookRouter {
    return new Contract(address, _abi, signerOrProvider) as OrderBookRouter;
  }
}
